import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PostContractualTermAccept,
	PostContractualTermAcceptModel,
	PostContractualTermAcceptParams,
} from 'domain/usecases/private/home/post-contractual-term-accept';

export class RemotePostContractualTermAccept implements PostContractualTermAccept {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostContractualTermAcceptModel>,
	) {}

	async post(params: PostContractualTermAcceptParams): Promise<PostContractualTermAcceptModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
